<template>
  <div class="container-flex fill-flex-full">
    <global-error v-if="globalError" />
    <div v-else class="container-right container-flex fill-flex-full">
      <div class="container-flex fill-flex-full">
        <div
          class="main container-flex fill-flex-full"
          v-if="client && client.billing"
        >
          <div class="container-fluid container-flex fill-flex-full bg-white">
            <div class="spacer-75"></div>

            <div class="spacer-40"></div>

            <div class="row px-dynamic mb-4">
              <div class="col h1-rem">{{ historyCurrentClname }}</div>
            </div>
            <date-form
              @download="downloadAct"
              @show="showActs"
              :error="error"
              :can-download="true"
            ></date-form>
            <ul class="nav row px-dynamic">
              <li class="nav-item" v-for="year in years" :key="year">
                <a
                  role="button"
                  class="nav-link"
                  :class="{ active: year === historySelectedYear }"
                  @click="setHistorySelectedYear(year)"
                  >{{ year }}</a
                >
              </li>
            </ul>
            <ul class="nav row px-dynamic">
              <li class="nav-item" v-for="month in selectedMonths" :key="month">
                <a
                  role="button"
                  class="nav-link"
                  :class="{ active: month === historySelectedMonth }"
                  @click="setHistorySelectedMonth(month)"
                  >{{ month.toLowerCase() }}</a
                >
              </li>
            </ul>
            <div class="row px-dynamic mt-4" v-show="empty.length > 0">
              <div class="col h2-rem">{{ empty }}</div>
            </div>
            <div
              class="row px-dynamic mt-5 justify-content-center align-items-center"
              v-show="loading"
            >
              <img src="@/assets/img/ajax-loader.gif" />
            </div>
            <div
              class="row px-dynamic mt-4"
              v-for="groupDiscount in selectedDiscounts"
              :key="groupDiscount.month + groupDiscount.year"
            >
              <div class="col h2-rem">
                {{ groupDiscount.month }} {{ groupDiscount.year }}
              </div>
              <div class="col-md-12 h3-rem">
                Сальдо на начало месяца:
                {{
                  groupDiscount.startBalance !== null
                    ? groupDiscount.startBalance.toFixed(2)
                    : ""
                }}&nbsp;₽
              </div>
              <div
                class="col-md-12 mt-4"
                v-if="groupDiscount.reports.length > 0"
              >
                <div class="row border-t-full">
                  <div class="col-md-3">
                    <p class="grey text-center">Идентификатор</p>
                  </div>
                  <div class="col-md-2">
                    <p class="grey text-center">Дата</p>
                  </div>
                  <div class="col-md-2">
                    <p class="grey text-center">Форма документа</p>
                  </div>
                  <div class="col-md-3">
                    <p class="grey text-center">Номер</p>
                  </div>
                  <!-- <div class="col-md-2">
                    <p class="grey text-center">Период</p>
                  </div> -->
                  <div class="col-md-2">
                    <p class="grey text-center">Сумма</p>
                  </div>
                </div>
                <div
                  class="row border-t-full"
                  v-for="(document, index) in groupDiscount.reports"
                  :key="index"
                >
                  <div class="col-md-3">
                    <p class="text-center">
                      <button
                        class="btn-link"
                        @click="downloadDocument(document.id)"
                      >
                        {{ document.id }}
                      </button>
                    </p>
                  </div>
                  <div class="col-md-2">
                    <p class="text-center">
                      {{
                        document.date
                          ? formatDate(document.date.substring(0, 10))
                          : ""
                      }}
                    </p>
                  </div>
                  <div class="col-md-2">
                    <p class="text-center">{{ document.form }}</p>
                  </div>
                  <div class="col-md-3">
                    <p class="text-center">{{ document.number }}</p>
                  </div>
                  <!-- <div class="col-md-2">
                    <p class="text-center">
                      {{ formatDate(document.period.substring(0, 7)) }}
                    </p>
                  </div> -->
                  <div class="col-md-2">
                    <p class="text-center" v-if="document.sum">
                      {{
                        document.sum !== null ? document.sum.toFixed(2) : ""
                      }}&nbsp;₽
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-4">
                <div class="row border-t-full">
                  <div class="col-md-8 border-t-right">
                    <div class="row">
                      <div class="col-md-12">
                        <p class="grey text-center">Списания</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <p class="grey text-center">Логин</p>
                      </div>
                      <div class="col-md-6">
                        <p class="grey text-center">Название услуги</p>
                      </div>
                      <div class="col-md-3">
                        <p class="grey text-center">Сумма</p>
                      </div>
                    </div>
                    <div
                      v-for="(obj, login, index) in groupDiscount.logins"
                      :key="index"
                    >
                      <div class="row border-t-full">
                        <div
                          class="col-md-3 d-flex align-items-center justify-content-center"
                        >
                          <p class="text-center">
                            {{ login }}
                          </p>
                          <div
                            class="ml-2"
                            v-if="Object.keys(obj.types).length > 1"
                          >
                            <a
                              @click="obj.show = !obj.show"
                              class="blue"
                              v-if="obj.types"
                              ><i
                                :class="
                                  obj.show
                                    ? 'fas fa-chevron-down'
                                    : 'fas fa-chevron-right'
                                "
                              ></i
                            ></a>
                          </div>
                        </div>
                        <div
                          class="col-md-3 offset-md-6 justify-content-center text-right pr-3"
                          v-if="Object.keys(obj.types).length > 1"
                        >
                          {{
                            obj.sum !== null ? obj.sum.toFixed(2) : ""
                          }}&nbsp;₽
                        </div>
                        <div
                          class="col-md-6 d-flex align-items-center justify-content-start"
                          v-if="Object.keys(obj.types).length == 1"
                        >
                          <p class="text-center">
                            {{
                              obj.types[Object.keys(obj.types)[0]].discounts[0]
                                .discounTypeName
                            }}
                          </p>
                          <div
                            class="ml-2"
                            v-if="
                              obj.types[Object.keys(obj.types)[0]].discounts
                                .length > 1
                            "
                          >
                            <a
                              @click="
                                obj.types[Object.keys(obj.types)[0]].show =
                                  !obj.types[Object.keys(obj.types)[0]].show
                              "
                              class="blue"
                              v-if="
                                obj.types[Object.keys(obj.types)[0]].discounts
                              "
                              ><i
                                :class="
                                  obj.types[Object.keys(obj.types)[0]].show
                                    ? 'fas fa-chevron-down'
                                    : 'fas fa-chevron-right'
                                "
                              ></i
                            ></a>
                          </div>
                        </div>
                        <div
                          class="col-md-3"
                          v-if="
                            Object.keys(obj.types).length == 1 &&
                            obj.types[Object.keys(obj.types)[0]].discounts
                              .length == 1
                          "
                        >
                          <p class="text-right mr-3">
                            {{
                              obj.types[
                                Object.keys(obj.types)[0]
                              ].discounts[0].sum.toFixed(2)
                            }}&nbsp;₽
                          </p>
                        </div>
                      </div>
                      <template
                        v-if="
                          obj.types[Object.keys(obj.types)[0]].show &&
                          obj.types[Object.keys(obj.types)[0]].discounts
                            .length > 1 &&
                          Object.keys(obj.types).length === 1
                        "
                      >
                        <div
                          class="row border-t-full"
                          v-for="discount in obj.types[
                            Object.keys(obj.types)[0]
                          ].discounts"
                          :key="discount"
                        >
                          <div class="offset-md-9 col-md-3">
                            <p class="text-right mr-3">
                              {{ discount.sum.toFixed(2) }}&nbsp;₽
                            </p>
                          </div>
                        </div>
                      </template>
                      <template v-if="obj.show">
                        <div
                          v-for="(service, dtype, index) in obj.types"
                          :key="index"
                        >
                          <div class="row border-t-full">
                            <div
                              class="offset-md-3 col-md-6 d-flex align-items-center justify-content-start"
                            >
                              <p class="text-center">
                                {{ dtype }}
                              </p>
                              <div
                                class="ml-2"
                                v-if="service.discounts.length > 1"
                              >
                                <a
                                  @click="service.show = !service.show"
                                  class="blue"
                                  v-if="service.discounts"
                                  ><i
                                    :class="
                                      service.show
                                        ? 'fas fa-chevron-down'
                                        : 'fas fa-chevron-right'
                                    "
                                  ></i
                                ></a>
                              </div>
                            </div>
                            <div
                              class="col-md-3 align-items-center justify-content-end text-right pr-3"
                              v-if="service.discounts.length > 1"
                            >
                              {{
                                service.sum !== null
                                  ? service.sum.toFixed(2)
                                  : ""
                              }}&nbsp;₽
                            </div>
                            <div
                              class="col-md-3"
                              v-if="service.discounts.length == 1"
                            >
                              <p class="text-right mr-3">
                                {{ service.discounts[0].sum.toFixed(2) }}&nbsp;₽
                              </p>
                            </div>
                          </div>
                          <template v-if="service.show">
                            <div
                              class="row border-t-full"
                              v-for="discount in service.discounts"
                              :key="discount"
                            >
                              <div class="offset-md-9 col-md-3">
                                <p class="text-right mr-3">
                                  {{
                                    discount.sum !== null
                                      ? discount.sum.toFixed(2)
                                      : ""
                                  }}&nbsp;₽
                                </p>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>

                    <!-- <div
                      class="row border-t-full"
                      v-for="discount in groupDiscount.discounts"
                      :key="discount"
                    >
                      <div class="col-md-3">
                        <p class="text-center">
                          {{ discount.login }}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p class="text-center">
                          {{ discount.discounTypeName }}
                        </p>
                      </div>
                      <div class="col-md-3">
                        <p class="text-center">{{ discount.sum }}&nbsp;₽</p>
                      </div>
                    </div>-->
                  </div>
                  <div class="col-md-4 mt-0">
                    <div class="row">
                      <div class="col-md-12">
                        <p class="grey text-center">Платежи</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <p class="grey text-center">Дата</p>
                      </div>
                      <div class="col-md-6">
                        <p class="grey text-center">Сумма</p>
                      </div>
                    </div>
                    <div
                      class="row border-t-full"
                      v-for="payment in groupDiscount.payments"
                      :key="payment"
                    >
                      <div class="col-md-6">
                        <p class="text-center">
                          {{ formatDate(payment.date.substring(0, 10)) }}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p class="text-right mr-3">
                          {{ payment.sum.toFixed(2) }}&nbsp;₽
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row border-t-full">
                  <div class="col-2"><p class="text-center">Итого:</p></div>
                  <div class="col-2 offset-4">
                    <p class="text-right mr-3">
                      {{
                        groupDiscount.discountsSum !== null
                          ? groupDiscount.discountsSum.toFixed(2)
                          : ""
                      }}&nbsp;₽
                    </p>
                  </div>
                  <div class="col-2"></div>
                  <div class="col-2">
                    <p class="text-right mr-3">
                      {{
                        groupDiscount.paymentsSum !== null
                          ? groupDiscount.paymentsSum.toFixed(2)
                          : ""
                      }}&nbsp;₽
                    </p>
                  </div>
                </div>
                <div class="row border-t-full">
                  <div class="col-2"><p class="text-center">Сальдо:</p></div>
                  <div class="col-2 offset-4">
                    <p class="text-right mr-3">
                      {{
                        groupDiscount.balance !== null
                          ? groupDiscount.balance.toFixed(2)
                          : ""
                      }}&nbsp;₽
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row px-dynamic ml-3 mt-4 h3-rem"
              v-if="selectedDiscounts && selectedDiscounts.length === 0"
            >
              Нет данных за этот месяц
            </div>
            <div class="fill-flex-full"></div>
            <div class="spacer-75"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script defer>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import GlobalError from "./GlobalError.vue";
import DateForm from "./DateForm.vue";
import config from "../config.js";

export default {
  components: {
    GlobalError,
    DateForm,
  },
  data() {
    return {
      months: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
      error: null,
      empty: "",
      years: [],
      // selectedYear: -1,
      // selectedMonth: "Январь",
    };
  },
  computed: {
    ...mapState([
      "reconciliationSuccess",
      "reconciliationError",
      "discounts",
      "payments",
      "balances",
      "reports",
      "groupDiscounts",
      "reportSuccess",
      "reportError",
      "loading",
      "historySelectedYear",
      "historySelectedMonth",
      "historyCurrentClname",
    ]),

    ...mapGetters(["globalError", "client"]),

    config() {
      return config;
    },

    selectedDiscounts() {
      if (this.groupDiscounts) {
        return this.groupDiscounts.filter(
          (item) =>
            item.year === this.historySelectedYear &&
            item.month === this.historySelectedMonth,
        );
      } else {
        return null;
      }
    },

    selectedMonths() {
      if (this.groupDiscounts) {
        return [
          ...new Set(
            this.groupDiscounts
              .filter((item) => item.year === this.historySelectedYear)
              .map((x) => x.month),
          ),
        ];
      } else {
        return null;
      }
    },
  },

  methods: {
    ...mapActions([
      "downloadCheckArt",
      "showReconciliation",
      "fetchClient",
      "downloadReport",
    ]),

    ...mapMutations([
      "setGroupDiscounts",
      "setHistorySelectedYear",
      "setHistorySelectedMonth",
      "setHistoryCurrentClname",
    ]),

    downloadAct(error, starttime, endtime, currentClnum) {
      const defaultErrorMessage = "Сервис временно недоступен";
      if (error === null) {
        const startmonth =
          (starttime.getMonth() < 8 ? "0" : "") +
          (starttime.getMonth() + 1).toString();
        const startdate = `${starttime
          .getFullYear()
          .toString()}-${startmonth}-01`;
        let endmonth =
          endtime.getMonth() > new Date().getMonth()
            ? endtime.getMonth() - 1
            : endtime.getMonth();
        endmonth = (endmonth < 8 ? "0" : "") + (endmonth + 1).toString();
        const enddate = `${endtime.getFullYear().toString()}-${endmonth}-01`;
        //this.error = `https://billing2.vrn.ru/generate/calculations-check-act/${this.currentClnum}?cca-date_from=${stime}&cca-date_to=${etime}`;
        this.downloadCheckArt({
          sdate: startdate,
          edate: enddate,
          clnum: currentClnum,
        }).then(() => {
          if (!this.reconciliationSuccess) {
            this.error = this.reconciliationError || defaultErrorMessage;
          } else {
            this.error = null;
          }
        });
      }
    },

    showActs(error, startTime, endTime, currentClnum, currentClname) {
      const defaultErrorMessage = "Сервис временно недоступен";
      this.setHistoryCurrentClname(currentClname);
      //this.currentClname = currentClname;
      if (error === null) {
        let currentTime = new Date(startTime.getTime());
        let groups = [];
        const startDate = `${startTime.getFullYear().toString()}-${(
          startTime.getMonth() + 1
        ).toString()}-01`;
        const endDate = `${endTime.getFullYear().toString()}-${(
          endTime.getMonth() + 2
        ).toString()}-01`;
        const startTimeBalance = new Date(startTime);
        startTimeBalance.setMonth(startTimeBalance.getMonth() - 1);
        const startDateBalance = `${startTimeBalance
          .getFullYear()
          .toString()}-${(startTimeBalance.getMonth() + 1).toString()}-01`;
        this.years = [];
        let countYears = endTime.getFullYear() - startTime.getFullYear();
        if (endTime.getMonth() === 0) countYears--;
        for (let i = 0; i <= countYears; i++) {
          this.years.push(startTime.getFullYear() + i);
        }
        this.showReconciliation({
          sdate: startDate,
          edate: endDate,
          sbdate: startDateBalance,
          clnum: parseInt(currentClnum),
        }).then(() => {
          if (this.reconciliationSuccess) {
            this.empty = "";
            let currentDiscount = 0;
            let currentPayment = 0;
            let currentBalance = 0;
            let currentReport = 0;
            const sortDiscounts = this.discounts.toSorted(
              (prev, next) => new Date(prev.date) - new Date(next.date),
            );
            const sortPayments = this.payments.toSorted(
              (prev, next) => new Date(prev.date) - new Date(next.date),
            );
            const sortReports = this.reports.toSorted(
              (prev, next) => new Date(prev.date) - new Date(next.date),
            );
            while (currentTime < endTime) {
              // Группировка документов, платежей и списаний по месяцам
              groups.push({
                year: currentTime.getFullYear(),
                month: this.months[currentTime.getMonth()],
                discounts: [],
                payments: [],
                discountsSum: 0,
                paymentsSum: 0,
                startBalance: this.balances[currentBalance++].sum,
                balance: this.balances[currentBalance].sum,
                reports: [],
                count: 0,
                logins: {},
              });
              const maxTime = new Date(currentTime);
              maxTime.setMonth(maxTime.getMonth() + 1);
              maxTime.setTime(
                maxTime.getTime() + maxTime.getTimezoneOffset() * 60000,
              );
              if (
                sortDiscounts.length > 0 &&
                currentDiscount < sortDiscounts.length
              ) {
                let discountTime = new Date(
                  sortDiscounts[currentDiscount].date,
                );
                while (
                  discountTime < maxTime &&
                  currentDiscount < sortDiscounts.length
                ) {
                  groups[groups.length - 1].discounts.push(
                    sortDiscounts[currentDiscount++],
                  );
                  if (currentDiscount < sortDiscounts.length) {
                    discountTime = new Date(
                      sortDiscounts[currentDiscount].date,
                    );
                  }
                }
                groups[groups.length - 1].discountsSum = groups[
                  groups.length - 1
                ].discounts.reduce(
                  (acc, discount) =>
                    discount.sum == null ? acc : acc + discount.sum,
                  0,
                );
              }
              let logins = {};
              for (
                let i = 0;
                i < groups[groups.length - 1].discounts.length;
                i++
              ) {
                if (groups[groups.length - 1].discounts[i].login in logins) {
                  if (
                    groups[groups.length - 1].discounts[i].discounTypeName in
                    logins[groups[groups.length - 1].discounts[i].login].types
                  ) {
                    logins[groups[groups.length - 1].discounts[i].login].types[
                      groups[groups.length - 1].discounts[i].discounTypeName
                    ].discounts.push(groups[groups.length - 1].discounts[i]);
                    logins[groups[groups.length - 1].discounts[i].login].types[
                      groups[groups.length - 1].discounts[i].discounTypeName
                    ].sum += groups[groups.length - 1].discounts[i].sum;
                    logins[groups[groups.length - 1].discounts[i].login].sum +=
                      groups[groups.length - 1].discounts[i].sum;
                  } else {
                    logins[groups[groups.length - 1].discounts[i].login].types[
                      groups[groups.length - 1].discounts[i].discounTypeName
                    ] = {
                      discounts: [],
                      show: false,
                      sum: 0,
                    };
                    logins[groups[groups.length - 1].discounts[i].login].types[
                      groups[groups.length - 1].discounts[i].discounTypeName
                    ].discounts.push(groups[groups.length - 1].discounts[i]);
                    logins[groups[groups.length - 1].discounts[i].login].types[
                      groups[groups.length - 1].discounts[i].discounTypeName
                    ].sum += groups[groups.length - 1].discounts[i].sum;
                    logins[groups[groups.length - 1].discounts[i].login].sum +=
                      groups[groups.length - 1].discounts[i].sum;
                  }
                } else {
                  logins[groups[groups.length - 1].discounts[i].login] = {
                    types: {},
                    show: false,
                    sum: 0,
                  };
                  if (
                    groups[groups.length - 1].discounts[i].discounTypeName in
                    logins[groups[groups.length - 1].discounts[i].login].types
                  ) {
                    logins[groups[groups.length - 1].discounts[i].login].types[
                      groups[groups.length - 1].discounts[i].discounTypeName
                    ].discounts.push(groups[groups.length - 1].discounts[i]);
                    logins[groups[groups.length - 1].discounts[i].login].sum +=
                      groups[groups.length - 1].discounts[i].sum;
                  } else {
                    logins[groups[groups.length - 1].discounts[i].login].types[
                      groups[groups.length - 1].discounts[i].discounTypeName
                    ] = {
                      discounts: [],
                      show: false,
                      sum: 0,
                    };
                    logins[groups[groups.length - 1].discounts[i].login].types[
                      groups[groups.length - 1].discounts[i].discounTypeName
                    ].discounts.push(groups[groups.length - 1].discounts[i]);
                    logins[groups[groups.length - 1].discounts[i].login].sum +=
                      groups[groups.length - 1].discounts[i].sum;
                  }
                }
              }
              groups[groups.length - 1].logins = logins;
              if (
                sortPayments.length > 0 &&
                currentPayment < sortPayments.length
              ) {
                let paymentTime = new Date(sortPayments[currentPayment].date);
                while (
                  paymentTime < maxTime &&
                  currentPayment < sortPayments.length
                ) {
                  groups[groups.length - 1].payments.push(
                    sortPayments[currentPayment++],
                  );
                  if (currentPayment < sortPayments.length) {
                    paymentTime = new Date(sortPayments[currentPayment].date);
                  }
                }
                groups[groups.length - 1].paymentsSum = groups[
                  groups.length - 1
                ].payments.reduce(
                  (acc, payment) =>
                    payment.sum == null ? acc : acc + payment.sum,
                  0,
                );
              }
              groups[groups.length - 1].count = Math.max(
                groups[groups.length - 1].discounts.length,
                groups[groups.length - 1].payments.length,
              );
              if (
                sortReports.length > 0 &&
                currentReport < sortReports.length
              ) {
                let reportTime = new Date(sortReports[currentReport].period);
                const minTime = new Date(startTime);
                minTime.setTime(
                  minTime.getTime() + minTime.getTimezoneOffset() * 60000,
                );
                while (
                  reportTime < maxTime &&
                  currentReport < sortReports.length
                ) {
                  if (reportTime >= minTime) {
                    groups[groups.length - 1].reports.push(
                      sortReports[currentReport],
                    );
                  }
                  if (++currentReport < sortReports.length) {
                    reportTime = new Date(sortReports[currentReport].period);
                  }
                }
              }
              if (groups[groups.length - 1].count === 0) {
                groups.pop();
              }
              currentTime.setMonth(currentTime.getMonth() + 1);
            }
            this.setGroupDiscounts(groups);
            if (groups.length === 0) {
              this.empty = "За данный период не было списаний и платежей";
            }
            this.error = null;
            // this.selectedYear = startTime.getFullYear();
            // this.selectedMonth = this.months[startTime.getMonth()];
            //this.selectedYear = endTime.getFullYear();
            //this.selectedMonth = this.months[endTime.getMonth() - 1];
            if (endTime.getMonth() === 0) {
              this.setHistorySelectedYear(endTime.getFullYear() - 1);
            } else {
              this.setHistorySelectedYear(endTime.getFullYear());
            }

            if (endTime.getMonth() === 0) {
              this.setHistorySelectedMonth(this.months[11]);
            } else {
              this.setHistorySelectedMonth(this.months[endTime.getMonth() - 1]);
            }
          } else {
            this.error = this.reconciliationError || defaultErrorMessage;
          }
        });
      }
    },

    downloadDocument(id) {
      const defaultErrorMessage = "Сервис временно недоступен";
      this.downloadReport({
        report_id: id,
      }).then(() => {
        if (!this.reportSuccess) {
          this.error = this.reportError || defaultErrorMessage;
        } else {
          this.error = null;
        }
      });
    },

    formatDate(date) {
      return date.split("-").reverse().join(".");
    },
  },

  created() {
    if (this.client === null) {
      this.fetchClient();
    }
    if (this.groupDiscounts) {
      // this.selectedYear = this.groupDiscounts[this.groupDiscounts.length - 1].year;
      this.years = [...new Set(this.groupDiscounts.map((group) => group.year))];
      // this.selectedMonth = this.selectedMonths[this.selectedMonth.length - 1];
    }
  },

  watch: {
    historySelectedYear() {
      //this.selectedMonth = this.selectedMonths[0];
      this.setHistorySelectedMonth(this.selectedMonths[0]);
    },
  },
};
</script>
